export default [
    { key: 'mail_type', label: 'Tipo' },
    { key: 'destination.name', label: 'Destino' },
    { key: 'owner.name', label: 'Para' },
    { key: 'user.name', label: 'Recibido por' },
    { key: 'notes', label: 'Notas' },
    { key: 'created_at', label: 'Recibido el' },
    { key: 'duration', label: 'Duración' },
]